import React, { useEffect, useState } from "react";
import { BsChevronDown, BsChevronUp, BsDot } from "react-icons/bs";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import axiosClient from "../../api/index";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "./components/Pagination";
import { BsGrid3X3GapFill } from "react-icons/bs";
import { TfiLayoutGrid4Alt } from "react-icons/tfi";
import { PiGridFourFill } from "react-icons/pi";
import { IoCloseCircle } from "react-icons/io5";

const Products = ({ resetCat, setResetCat }) => {
  const searchParams = new URLSearchParams(window.location.search);
  const navigate = useNavigate();

  const queryCategory = searchParams.get("category")?.split(",") || [];
  const queryBrand = searchParams.get("brand")?.split(",") || [];
  const queryAttributes = searchParams.get("attribute")?.split(",") || [];

  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState(queryCategory);
  const [selectedBrands, setSelectedBrands] = useState(queryBrand);
  const [products, setProducts] = useState([]);
  const [attributeFilters, setAttributeFilters] = useState(queryAttributes);
  const [currentPage, setCurrentPage] = useState(1);
  const [categoryIsLoading, categorySetIsLoading] = useState(true);
  const [brandIsLoading, brandSetIsLoading] = useState(true);
  const [productIsLoading, productSetIsLoading] = useState(true);
  const [attributeGroups, setAttributeGroups] = useState({});
  const [showCount, setShowCount] = useState(12);
  const [showGrid, setShowGrid] = useState(3);
  const [value, setValue] = useState("");
  const [desktopValue, setDesktopValue] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [availableBrands, setAvailableBrands] = useState([]);
  const [showCategory, setShowCategory] = useState(true);
  const [showBrand, setShowBrand] = useState(true);
  const [showAttributeGroups, setShowAttributeGroups] = useState({});

  const indexOfLastItem = currentPage * showCount;
  const indexOfFirstItem = indexOfLastItem - showCount;
  const currentItems = products.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const arraysEqual = (a, b) => {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  };

  useEffect(() => {
    if (resetCat) {
      setSelectedCategories([]);
      setSelectedBrands([]);
      setAttributeFilters([]);
      setResetCat(false);
    }
  }, [resetCat]);
  console.log(resetCat);
  useEffect(() => {
    if (
      queryCategory.length > 0 &&
      !arraysEqual(queryCategory, selectedCategories)
    ) {
      setSelectedCategories(queryCategory);
    }
  }, [queryCategory, selectedCategories]);

  useEffect(() => {
    axiosClient
      .get("/Category/GetAllCategoryHierarchy")
      .then((res) => {
        setCategories(res.data.categories);
        categorySetIsLoading(false);
      })
      .catch(() => categorySetIsLoading(false));
  }, []);

  useEffect(() => {
    axiosClient
      .get("/Brand")
      .then((res) => {
        if (selectedCategories.length === 0) {
          setAvailableBrands(res.data.brands.map((brand) => brand.name));
        }
        brandSetIsLoading(false);
      })
      .catch(() => brandSetIsLoading(false));
  }, [selectedCategories]);

  useEffect(() => {
    productSetIsLoading(true);

    const params = new URLSearchParams();
    selectedCategories.forEach((cat) => params.append("category", cat));
    selectedBrands.forEach((brand) => params.append("brand", brand));
    attributeFilters.forEach((attr) => params.append("attribute", attr));
    axiosClient
      .post(`/Filter/FilterProduct?${params.toString()}`)
      .then((res) => {
        const sortedProducts = [
          ...res.data.products.filter(
            (product) => product.brandName === "Point Mobile"
          ),
          ...res.data.products.filter(
            (product) => product.brandName !== "Point Mobile"
          ),
        ];
        setProducts(sortedProducts);
        setAllProducts(sortedProducts);
        productSetIsLoading(false);
      })
      .catch((error) => {
        console.error("Error while fetching filtered data:", error);
        productSetIsLoading(false);
      });
  }, [selectedCategories, selectedBrands, attributeFilters]);

  useEffect(() => {
    if (selectedCategories.length > 0) {
      const params = new URLSearchParams();
      selectedCategories.forEach((cat) => params.append("category", cat));

      axiosClient
        .post(`/Filter/FilterProduct?${params.toString()}`)
        .then((res) => {
          setAttributeGroups(groupAttributes(res.data.products));
          const filteredBrands = res.data.products.map(
            (product) => product.brandName
          );
          setAvailableBrands([...new Set(filteredBrands)]); // Remove duplicates
        })
        .catch((error) => {
          console.error("Error while fetching attributes data:", error);
        });
    }
    setCurrentPage(1);
  }, [selectedCategories]);

  const toggleSelected = (currentList, item, setter) => {
    let updatedList;

    if (setter === setSelectedCategories) {
      // Ensure only one category is selected at a time
      updatedList = currentList.includes(item) ? [] : [item];
      setSelectedCategories(updatedList);
      updateURLParams(updatedList, selectedBrands, attributeFilters);
    } else {
      updatedList = currentList.includes(item)
        ? currentList.filter((i) => i !== item)
        : [...currentList, item];

      setter(updatedList);
      if (setter === setSelectedBrands) {
        updateURLParams(selectedCategories, updatedList, attributeFilters);
      } else {
        updateURLParams(selectedCategories, selectedBrands, updatedList);
      }
    }
  };

  const updateURLParams = (categories, brands, attributes) => {
    const params = new URLSearchParams();

    if (categories.length > 0) {
      params.set("category", categories.join(","));
    }

    if (brands.length > 0) {
      params.set("brand", brands.join(","));
    }

    if (attributes.length > 0) {
      params.set("attribute", attributes.join(","));
    }

    navigate(`/urunler?${params.toString()}`);
  };

  const groupAttributes = (products) => {
    const attributeGroups = {};
    const activeAttributes = new Set();

    products?.forEach((product) => {
      product?.product?.productAttribute?.forEach((attribute) => {
        const { attributeName, attributeDescription, isActive } = attribute;

        if (!attributeGroups[attributeName]) {
          attributeGroups[attributeName] = new Map();
        }

        if (!attributeGroups[attributeName].has(attributeDescription)) {
          attributeGroups[attributeName].set(attributeDescription, 1);
        } else {
          attributeGroups[attributeName].set(
            attributeDescription,
            attributeGroups[attributeName].get(attributeDescription) + 1
          );
        }

        if (isActive) {
          activeAttributes.add(attributeName);
        }
      });
    });

    const filteredAttributeGroups = {};

    Object.keys(attributeGroups).forEach((key) => {
      if (activeAttributes.has(key)) {
        filteredAttributeGroups[key] = Array.from(
          attributeGroups[key].entries()
        )
          .filter(([, count]) => count === 1)
          .map(([description]) => description);
      }
    });

    return filteredAttributeGroups;
  };

  const resetAttributeGroups = () => {
    setAttributeGroups({});
  };

  useEffect(() => {
    if (
      selectedCategories.length === 0 &&
      selectedBrands.length === 0 &&
      attributeFilters.length === 0
    ) {
      resetAttributeGroups();
    }
  }, [selectedCategories, selectedBrands, attributeFilters]);

  const handleShowCount = (count) => {
    setShowCount(count);
  };

  const handleShowGrid = (grid) => {
    setShowGrid(grid);
  };

  React.useEffect(() => {
    setShowCount(12);
    setShowGrid(4);
  }, []);

  useEffect(() => {
    if (value === "") {
      return setProducts(allProducts);
    }
    const filteredProducts = allProducts.filter((product) =>
      product?.product.name.toLowerCase().includes(value.toLowerCase())
    );
    setProducts(filteredProducts);
  }, [value, allProducts]);

  useEffect(() => {
    if (desktopValue === "") {
      return setProducts(allProducts);
    }

    const filteredProducts = allProducts.filter((product) =>
      product?.product.name.toLowerCase().includes(desktopValue.toLowerCase())
    );

    setProducts(filteredProducts);
  }, [desktopValue, allProducts]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleAttributeGroup = (attributeName) => {
    setShowAttributeGroups((prev) => ({
      ...prev,
      [attributeName]: !prev[attributeName],
    }));
  };

  return (
    <div>
      <div className="container mx-auto py-10">
        <div className="flex items-center gap-2">
          <p className="text-main text-lg font-semibold mb-4">Ana Sayfa</p>
          <p className="text-main text-lg font-semibold mb-4">
            <BsDot size={22} />
          </p>
          <p className="text-main text-lg font-semibold mb-4">Ürünler</p>
        </div>
        <div>
          <h1 className="font-semibold text-4xl">Ürünler</h1>
        </div>
        <div className="items-center justify-center max-md:flex hidden max-md:mt-5">
          <p className="text-main text-2xl font-semibold mb-4">
            {selectedCategories}
          </p>
        </div>
        <div className="flex gap-10 mt-10 max-md:flex-col max-md:mt-4">
          <div className="sidebar flex-[2_2_0] rounded-md max-md:hidden">
            <div className="mb-6">
              <div
                onClick={() => setShowCategory(!showCategory)}
                className="flex items-center justify-between border-b-[1px] border-gray-200 mb-3 cursor-pointer"
              >
                <div className="flex items-center justify-between w-full gap-2">
                  <p className="font-semibold text-3xl flex items-center">
                    Kategoriler
                    {selectedCategories.length > 0 && (
                      <span className="text-main font-semibold text-lg ml-5">
                        ( {selectedCategories.length} )
                      </span>
                    )}
                  </p>
                  {showCategory ? (
                    <BsChevronUp className="text-main text-xl" />
                  ) : (
                    <BsChevronDown className="text-main text-xl" />
                  )}
                </div>
              </div>
              {showCategory && (
                <ul className="h-[400px] overflow-y-scroll custom-scrollbar">
                  {categoryIsLoading
                    ? Array.from({ length: 10 }).map((_, index) => (
                        <li key={index} className="mb-1">
                          <Skeleton
                            className="h-10 w-full"
                            height={25}
                            width={`80%`}
                          />
                          <ul>
                            <li className="ml-3">
                              <Skeleton
                                className="h-10 w-full"
                                height={20}
                                width={`70%`}
                              />
                            </li>
                          </ul>
                        </li>
                      ))
                    : categories.map((category) => (
                        <li key={category.id} className={`mb-1`}>
                          <span
                            onClick={() => {
                              toggleSelected(
                                selectedCategories,
                                category.name,
                                setSelectedCategories
                              );
                            }}
                            className={`
                       text-gray-800 text-lg hover:text-gray-900 font-semibold cursor-pointer ${
                         selectedCategories.includes(category.name)
                           ? "bg-gray-300 px-2"
                           : ""
                       }`}
                          >
                            {category.name}
                          </span>
                          <ul>
                            {category?.subCategories?.map((subCategory) => (
                              <li
                                key={subCategory.id}
                                className={`ml-3 ${
                                  selectedCategories.includes(subCategory.name)
                                    ? "bg-gray-300 px-2"
                                    : ""
                                } text-gray-600 text-md font-medium cursor-pointer hover:text-gray-800`}
                              >
                                <span
                                  onClick={() =>
                                    toggleSelected(
                                      selectedCategories,
                                      subCategory.name,
                                      setSelectedCategories
                                    )
                                  }
                                >
                                  {subCategory.name.includes("-1")
                                    ? subCategory.name.slice(0, -2)
                                    : subCategory.name}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                </ul>
              )}
            </div>
            <div className="flex items-center justify-between">
              <span
                className="font-semibold text-3xl cursor-pointer"
                onClick={() => setShowBrand(!showCategory)}
              >
                Filtreler
              </span>
            </div>

            <div className="mt-5">
              <div
                onClick={() => setShowBrand(!showBrand)}
                className="flex items-center justify-between border-b-[1px] border-gray-200 mb-3 cursor-pointer"
              >
                <div className="flex items-center w-full justify-between gap-2">
                  <p className="font-semibold text-xl flex items-center">
                    Markalar
                    {selectedBrands.length > 0 && (
                      <span className="text-main font-semibold text-lg ml-5">
                        ( {selectedBrands.length} )
                      </span>
                    )}
                  </p>
                  {showBrand ? (
                    <BsChevronUp
                      onClick={() => setShowBrand(!showBrand)}
                      className="text-main text-xl"
                    />
                  ) : (
                    <BsChevronDown
                      onClick={() => setShowBrand(!showBrand)}
                      className="text-main text-xl"
                    />
                  )}
                </div>
              </div>
              {showBrand && (
                <ul className="h-[300px] overflow-y-scroll custom-scrollbar">
                  {availableBrands
                    .sort((a, b) => a.localeCompare(b))
                    .map((brand) => (
                      <li
                        key={brand}
                        onClick={() => {
                          toggleSelected(
                            selectedBrands,
                            brand,
                            setSelectedBrands
                          );
                          window.scrollTo(0, 0);
                        }}
                        className={`mb-1 ${
                          selectedBrands.includes(brand)
                            ? "bg-gray-300 px-2"
                            : ""
                        }`}
                      >
                        <span className="text-gray-800 text-lg font-semibold cursor-pointer hover:text-gray-900">
                          {brand}
                        </span>
                      </li>
                    ))}
                </ul>
              )}
            </div>
            <div className="mt-5">
              <ul>
                {Object.entries(attributeGroups).map(
                  ([attributeName, descriptions]) => (
                    <li
                      className={`mb-5 ${
                        showAttributeGroups[attributeName] &&
                        descriptions.length > 5
                          ? "h-[300px] overflow-y-scroll custom-scrollbar"
                          : ""
                      }`}
                      key={attributeName}
                    >
                      <div
                        onClick={() => toggleAttributeGroup(attributeName)}
                        className="flex items-center justify-between border-b-[1px] border-gray-200 mb-3 cursor-pointer"
                      >
                        <div className="flex items-center gap-2">
                          <span className="font-semibold text-xl">
                            {attributeName}
                          </span>
                          {attributeFilters.filter((attr) =>
                            descriptions.includes(attr)
                          ).length > 0 && (
                            <span className="text-main font-semibold text-lg">
                              ({" "}
                              {
                                attributeFilters.filter((attr) =>
                                  descriptions.includes(attr)
                                ).length
                              }{" "}
                              )
                            </span>
                          )}
                        </div>
                        <div>
                          {showAttributeGroups[attributeName] ? (
                            <BsChevronUp className="text-main text-xl" />
                          ) : (
                            <BsChevronDown className="text-main text-xl" />
                          )}
                        </div>
                      </div>
                      {showAttributeGroups[attributeName] && (
                        <ul>
                          {descriptions.map((description, index) => (
                            <li
                              onClick={() => {
                                toggleSelected(
                                  attributeFilters,
                                  description,
                                  setAttributeFilters
                                );
                                window.scrollTo(0, 0);
                              }}
                              className={`ml-3 mb-1 ${
                                attributeFilters.includes(description)
                                  ? "bg-gray-300 px-2"
                                  : ""
                              } text-gray-800 text-lg font-semibold cursor-pointer hover:text-gray-900`}
                              key={index}
                            >
                              - {description}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>

          <div className="relative flex-[8_8_0]">
            <div className="flex items-center justify-between mb-5 max-md:hidden">
              <div className="flex items-center gap-5">
                <div className="flex items-center gap-3">
                  <p className="font-semibold text-xl">Göster:</p>
                  <div className="flex items-center gap-2">
                    <p
                      onClick={() => handleShowCount(12)}
                      className={`font-semibold text-lg cursor-pointer ${
                        showCount === 12 ? "text-main" : "text-gray-500"
                      }`}
                    >
                      12
                    </p>
                    <p className="text-gray-500 text-lg">/</p>
                    <p
                      onClick={() => handleShowCount(24)}
                      className={`font-semibold text-lg cursor-pointer ${
                        showCount === 24 ? "text-main" : "text-gray-500"
                      }`}
                    >
                      24
                    </p>
                    <p className="text-gray-500 text-lg">/</p>
                    <p
                      onClick={() => handleShowCount(36)}
                      className={`font-semibold text-lg cursor-pointer ${
                        showCount === 36 ? "text-main" : "text-gray-500"
                      }`}
                    >
                      36
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <p className="font-semibold text-xl">Görünüm:</p>
                  <div className="flex items-center gap-2">
                    <PiGridFourFill
                      onClick={() => handleShowGrid(2)}
                      className={`text-2xl cursor-pointer ${
                        showGrid === 2 ? "text-main" : "text-gray-500"
                      }`}
                    />
                    <BsGrid3X3GapFill
                      onClick={() => handleShowGrid(3)}
                      className={`text-2xl cursor-pointer ${
                        showGrid === 3 ? "text-main" : "text-gray-500"
                      }`}
                    />
                    <TfiLayoutGrid4Alt
                      onClick={() => handleShowGrid(4)}
                      className={`text-2xl cursor-pointer ${
                        showGrid === 4 ? "text-main" : "text-gray-500"
                      }`}
                    />
                  </div>
                </div>
              </div>
              <input
                type="text"
                value={desktopValue}
                onChange={(e) => setDesktopValue(e.target.value)}
                placeholder="Ara..."
                className="w-full md:w-[300px] outline-none h-10 border border-gray-300 rounded-md px-3"
              />
            </div>
            <div className="mb-10 max-md:hidden">
              <p className="font-semibold text-xl">Seçilen Filtreler:</p>
              <div className="flex justify-between w-full items-center gap-2">
                <div className="flex items-center flex-wrap gap-2 flex-[8_8_0]">
                  {selectedCategories.map((category) => (
                    <div
                      key={category}
                      className="bg-main text-white px-2 py-1 rounded-md inline-block cursor-pointer"
                      onClick={
                        category.includes("-1")
                          ? () => {
                              toggleSelected(
                                selectedCategories,
                                category.slice(0, -2),
                                setSelectedCategories
                              );
                            }
                          : () => {
                              toggleSelected(
                                selectedCategories,
                                category,
                                setSelectedCategories
                              );
                            }
                      }
                    >
                      <p className="flex items-center">
                        {category.includes("-1")
                          ? category.slice(0, -2)
                          : category}

                        <IoCloseCircle className="text-white text-lg ml-2" />
                      </p>
                    </div>
                  ))}
                  {selectedBrands.map((brand) => (
                    <div
                      key={brand}
                      className="bg-main text-white px-2 py-1 rounded-md cursor-pointer"
                      onClick={
                        brand.includes("-1")
                          ? () => {
                              toggleSelected(
                                selectedBrands,
                                brand.slice(0, -2),
                                setSelectedBrands
                              );
                            }
                          : () => {
                              toggleSelected(
                                selectedBrands,
                                brand,
                                setSelectedBrands
                              );
                            }
                      }
                    >
                      <p className="flex items-center">
                        {brand}{" "}
                        <IoCloseCircle className="text-white text-lg ml-2" />
                      </p>
                    </div>
                  ))}

                  {attributeFilters.map((attribute) => (
                    <div
                      key={attribute}
                      className="bg-main text-white px-2 py-1 rounded-md cursor-pointer"
                      onClick={
                        attribute.includes("-1")
                          ? () => {
                              toggleSelected(
                                attributeFilters,
                                attribute.slice(0, -2),
                                setAttributeFilters
                              );
                            }
                          : () => {
                              toggleSelected(
                                attributeFilters,
                                attribute,
                                setAttributeFilters
                              );
                            }
                      }
                    >
                      <p className="flex items-center">
                        {attribute}
                        <IoCloseCircle className="text-white text-lg ml-2" />
                      </p>
                    </div>
                  ))}
                </div>
                <div className="flex items-start justify-end flex-[2_2_0] h-full">
                  {selectedCategories.length > 0 ||
                  selectedBrands.length > 0 ||
                  attributeFilters.length > 0 ? (
                    <button
                      className=" text-main underline font-semibold text-lg px-2 py-1 rounded-md"
                      onClick={() => {
                        setSelectedCategories([]);
                        setSelectedBrands([]);
                        setAttributeFilters([]);
                        updateURLParams([], [], []);
                      }}
                    >
                      Filtreleri Temizle
                    </button>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between mb-5 md:hidden">
              <input
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Ara..."
                className="w-full md:w-[300px] outline-none h-10 border border-gray-300 rounded-md px-3"
              />
            </div>

            <div
              className={`md:grid-cols-2 lg:grid-cols-3 gap-6 relative ${
                showGrid === 2
                  ? "grid xl:grid-cols-2"
                  : showGrid === 3
                  ? "grid xl:grid-cols-3"
                  : "grid xl:grid-cols-4"
              }`}
            >
              {productIsLoading ? (
                Array.from({ length: showCount }).map((_, index) => (
                  <Skeleton key={index} height={250} width={`100%`} />
                ))
              ) : products.length <= 0 ? (
                <div className="col-span-full flex items-center justify-center h-[calc(100vh-100px)]">
                  <h1 className="text-center font-semibold text-xl">
                    Bu kategoriye veya markaya ait ürün bulunamadı.
                  </h1>
                </div>
              ) : (
                currentItems.map((item) => (
                  <div
                    key={item.product ? item.product.id : item.id}
                    className="rounded-lg border border-gray-300 relative overflow-hidden cursor-pointer py-5"
                  >
                    <Link
                      to={`/urunler/urun-detay/${
                        item?.product?.permalink || item?.permalink
                      }`}
                      className="flex flex-col items-center justify-center"
                    >
                      <div className="w-full flex justify-center items-center h-40">
                        <img
                          src={`https://cdn.lensa.com.tr/${
                            item?.product?.photos?.[0]?.photoUrl ||
                            item?.images?.[0]?.photoUrl
                          }`}
                          alt=""
                          className="object-contain h-full w-full"
                        />
                      </div>
                      <div className="flex justify-center flex-col mt-5">
                        <h1 className="text-xl font-semibold px-3 max-2xl:leading-[1.2rem] text-center">
                          {item?.product?.name || item?.name}
                        </h1>
                      </div>
                    </Link>
                  </div>
                ))
              )}
            </div>

            <Pagination
              totalItems={products.length}
              itemsPerPage={showCount}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
